import { DataService } from '../../services/data.service';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { pushToObject, removeStingArray, pushStringArray } from 'src/app/services/convert.service';
import { IClassSchedule, IClassReading } from 'src/app/interfaces/enrollment';

@Injectable()
export class ClassroomStore {
    @observable data: any[] = [];
    @observable schedules = [];
    @observable reading = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable fetching: boolean = false;
    @observable selectedClass: any = null;
    @observable studentdata: any[] = [];
    @observable studentArray = [];

    constructor(private ds: DataService) { }

    @action
    fetchSchedules(classRoomKey: string) {
        this.loading = true;
        this.ds.classroomScheduleRef(classRoomKey).valueChanges().subscribe(docs => {
            this.schedules = docs;
            this.loading = false;
        })
    }

    @action
    fetchReading(classRoomKey: string) {
        this.loading = true;
        this.ds.classroomReadingRef(classRoomKey).valueChanges().subscribe(docs => {
            this.reading = docs;
            this.loading = false;
        })
    }

    @action
    async fetchClassroom(classroomKey) {
        const docs = await this.ds.classRoomRef().doc(classroomKey).get().toPromise();
        this.selectedClass = pushToObject(docs);
        if (this.selectedClass && this.selectedClass.studentArray) {
            this.studentArray = this.selectedClass.studentArray
        }
        return this.selectedClass;
    }


    @action
    async fetchStudentClassroom(classroomKey) {
        this.ds.classRoomRef().doc(classroomKey).collection('students').valueChanges().subscribe(data => {
            this.studentdata = data
        });
    }


    @action
    async addStudent(data, classroomKey, callback) {
        const batch = this.ds.batch()
        const classRef = await this.ds.classRoomFireRef().doc(classroomKey);
        const subClassRef = await this.ds.classRoomFireRef().doc(classroomKey).collection('students').doc(data.key);
        this.fetchClassroom(classroomKey)
        batch.set(subClassRef, data);
        const array = [
            data.key
        ]
        this.studentArray = this.studentArray.concat(array)
        const uniqueSet = Array.from(new Set(this.studentArray))
        batch.update(classRef,
            {
                studentArray: uniqueSet
            }
        )
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })

    }

    @action
    async removeStudent(data, classroomKey, callback) {
        const batch = this.ds.batch()
        const classRef = await this.ds.classRoomFireRef().doc(classroomKey);
        const subClassRef = await this.ds.classRoomFireRef().doc(classroomKey).collection('students').doc(data.key);

        batch.delete(subClassRef);
        this.fetchClassroom(classroomKey)
        let filteredAry = this.studentArray.filter(e => { return e !== data.key })
        batch.update(classRef,
            {
                studentArray: filteredAry
            }
        )
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async addReadingBook(item: IClassReading, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { classRoomKey, key } = item;
        const classRoomDoc = await this.ds.classRoomRef().doc(classRoomKey).get().toPromise();
        const classRoomData = pushToObject(classRoomDoc);

        const { readingBookArray } = classRoomData;
        const readingBookArrayData = pushStringArray(readingBookArray, key);

        const classRoomRef = this.ds.classRoomFireRef().doc(classRoomKey);

        batch.update(classRoomRef, { readingBookArray: readingBookArrayData });
        batch.set(classRoomRef.collection("class_reading_book").doc(key), item);

        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async deleteReadingBook(item: IClassSchedule, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { classRoomKey, key } = item;
        const classRoomDoc = await this.ds.classRoomRef().doc(classRoomKey).get().toPromise();
        const classRoomData = pushToObject(classRoomDoc);

        const { readingBookArray } = classRoomData;
        const readingBookArrayData = pushStringArray(readingBookArray, key);

        const classRoomRef = this.ds.classRoomFireRef().doc(classRoomKey);

        batch.update(classRoomRef, { readingBookArray: readingBookArrayData });
        batch.delete(classRoomRef.collection("class_reading_book").doc(key));

        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }


    @action
    async addSchedule(item: IClassSchedule, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { classRoomKey, key } = item;
        const classRoomDoc = await this.ds.classRoomRef().doc(classRoomKey).get().toPromise();
        const classRoomData = pushToObject(classRoomDoc);

        const { scheduleArray } = classRoomData;
        const scheduleArrayData = pushStringArray(scheduleArray, key);

        const classRoomRef = this.ds.classRoomFireRef().doc(classRoomKey);

        batch.update(classRoomRef, { scheduleArray: scheduleArrayData });
        batch.set(classRoomRef.collection("schedules").doc(key), item);

        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async updateSchedule(item: IClassSchedule, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { classRoomKey, key } = item;

        const classRoomRef = this.ds.classRoomFireRef().doc(classRoomKey);
        batch.update(classRoomRef.collection("schedules").doc(key), item);

        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async deleteSchedule(item: IClassSchedule, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { classRoomKey, key } = item;
        const classRoomDoc = await this.ds.classRoomRef().doc(classRoomKey).get().toPromise();
        const classRoomData = pushToObject(classRoomDoc);

        const { scheduleArray } = classRoomData;
        const scheduleArrayData = removeStingArray(scheduleArray, key);

        const classRoomRef = this.ds.classRoomFireRef().doc(classRoomKey);

        batch.update(classRoomRef, { scheduleArray: scheduleArrayData });
        batch.delete(classRoomRef.collection("schedules").doc(key));

        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

}
